"use client";

import { useTranslations } from "next-intl";

/**
 * Shown instead of a sign-in form wherever the funnel would otherwise ask the
 * user to authenticate, when Discover is embedded in the Spond app's WebView
 * with no valid session. The user cannot sign in there, so the app
 * (re-entering with a fresh code) is the only recovery path — deliberately no
 * form and no link to the web sign-in page, which would put that unreachable
 * path back within reach.
 */
export default function ContinueInAppState() {
  const t = useTranslations("publicEventSignup");

  return (
    <div className="flex h-full flex-col gap-4">
      <div className="flex flex-col gap-1">
        <h2 className="text-lg font-semibold">{t("continueInApp.header")}</h2>
        <p className="text-sm text-muted-foreground">
          {t("continueInApp.body")}
        </p>
      </div>
    </div>
  );
}
